import { useEffect } from 'react';

import { env } from '@/env';
import { isMobileBrowser } from '@/utils/device';

// Routes a phone-class mobile browser to Gearbelt Mobile Web. Returns whether a
// redirect is in flight so the caller can hold a loader instead of flashing the
// desktop UI. `shouldRoute` carries the workspace migration flag, resolved
// differently per entry point (authenticated store vs public-workspace lookup).
export function useGbmwDeviceRedirect(shouldRoute: boolean): boolean {
  const gbmwUrl = shouldRoute && isMobileBrowser() ? env.VITE_GBMW_URL : undefined;

  useEffect(() => {
    if (gbmwUrl) {
      window.location.replace(gbmwUrl);
    }
  }, [gbmwUrl]);

  return !!gbmwUrl;
}
